<div class="modal-header">
  <button mat-icon-button class="close-btn" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
  <div class="modal-title">Import Contractor Type</div>
  <div class="modal-subtitle" *ngIf="prepareResponse">
    Source: <strong>{{ prepareResponse.contractorTypeName }}</strong>
  </div>
</div>

<mat-dialog-content class="import-ct-modal">
  <ng-container *ngIf="isPreparing">
    <app-loader></app-loader>
    <div class="text-center mt-2">Analyzing export file...</div>
  </ng-container>

  <mat-accordion *ngIf="!isPreparing" multi="true">
    <mat-expansion-panel
      *ngFor="let section of sections; let i = index"
      class="custom-panel"
      [hidden]="!section.enabled"
      [expanded]="expandedIndex === i"
      (opened)="expandedIndex = i"
      [hideToggle]="true"
    >
      <mat-expansion-panel-header>
        <mat-panel-title class="panel-title">{{
          section.label
        }}</mat-panel-title>
        <mat-panel-description class="panel-icon">
          <span *ngIf="section.completed" class="success-icon">✔</span>
          <span
            *ngIf="!section.completed && section.enabled"
            class="warning-icon"
            >⚠</span
          >
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="section-body">
        <ng-container [ngSwitch]="section.key">
          <!-- ── File Select ── -->
          <div *ngSwitchCase="'file-select'">
            <p class="text-muted mb-3">
              Select the JSON file exported from the source environment.
            </p>
            <div class="form-group">
              <input
                type="file"
                accept=".json,application/json"
                class="form-control-file"
                (change)="onFileSelected($event)"
                [disabled]="isPreparing"
              />
            </div>
            <div *ngIf="fileSelectError" class="alert alert-danger mt-2">
              {{ fileSelectError }}
            </div>
          </div>

          <!-- ── Contractor Type Settings ── -->
          <div *ngSwitchCase="'ct-settings'">
            <form [formGroup]="ctSettingsForm">
              <div class="form-group">
                <wm-common-textfield
                  formControlName="name"
                  [data]="{
                    label: 'Contractor Type Name',
                    placeholder: 'Enter name'
                  }"
                >
                </wm-common-textfield>
              </div>
              <div class="form-group">
                <wm-common-textfield
                  formControlName="description"
                  [data]="{
                    label: 'Description',
                    placeholder: 'Enter description'
                  }"
                >
                </wm-common-textfield>
              </div>
            </form>
            <div class="import-modal-actions">
              <wm-common-button
                (click)="section.completed = true; nextSection()"
                [disabled]="ctSettingsForm.invalid"
                [data]="{ text: 'Next', type: 'primary' }"
              >
              </wm-common-button>
            </div>
          </div>

          <!-- ── Register / Renew: Workflow Settings ── -->
          <div *ngSwitchCase="'register-settings'">
            <div
              class="form-group"
              *ngIf="registerWorkflowConfig?.workflowUpdates"
            >
              <wm-common-textfield
                [(ngModel)]="registerWorkflowConfig.workflowUpdates.name"
                [data]="{
                  label: 'Register Workflow Name',
                  placeholder: 'Enter workflow name'
                }"
              >
              </wm-common-textfield>
            </div>
            <div class="import-modal-actions">
              <wm-common-button
                (click)="
                  section.completed = true;
                  registerWorkflowConfig.workflowUpdates.completed = true;
                  nextSection()
                "
                [data]="{ text: 'Next', type: 'primary' }"
              >
              </wm-common-button>
            </div>
          </div>

          <div *ngSwitchCase="'renew-settings'">
            <div
              class="form-group"
              *ngIf="renewWorkflowConfig?.workflowUpdates"
            >
              <wm-common-textfield
                [(ngModel)]="renewWorkflowConfig.workflowUpdates.name"
                [data]="{
                  label: 'Renew Workflow Name',
                  placeholder: 'Enter workflow name'
                }"
              >
              </wm-common-textfield>
            </div>
            <div class="import-modal-actions">
              <wm-common-button
                (click)="
                  section.completed = true;
                  renewWorkflowConfig.workflowUpdates.completed = true;
                  nextSection()
                "
                [data]="{ text: 'Next', type: 'primary' }"
              >
              </wm-common-button>
            </div>
          </div>

          <!-- ── Register: Roles ── -->
          <div *ngSwitchCase="'register-roles'">
            <div
              *ngFor="
                let mapping of registerWorkflowConfig?.roleMappings?.mappings ||
                  []
              "
              class="card-box mb-2"
            >
              <div class="row align-items-center">
                <div class="col-5">
                  <small class="text-muted">Source role</small>
                  <div class="font-weight-medium">
                    {{ mapping.sourceRoleName }}
                  </div>
                </div>
                <div class="col-1 text-center text-muted">&rarr;</div>
                <div class="col-6">
                  <small class="text-muted"
                    >Maps to target role
                    <span class="text-danger">*</span></small
                  >
                  <select
                    class="form-control form-control-sm"
                    [(ngModel)]="mapping.targetRoleId"
                  >
                    <option [value]="null">+ Add Role to Destination</option>
                    <option
                      *ngFor="
                        let role of registerWorkflowOptions
                          ?.targetJurisdictionResources?.responsibleRoles
                      "
                      [value]="role.id"
                      >{{ role.name }}</option
                    >
                  </select>
                </div>
              </div>
            </div>
            <div class="import-modal-actions">
              <wm-common-button
                (click)="
                  section.completed = true;
                  registerWorkflowConfig.roleMappings.completed = true;
                  nextSection()
                "
                [data]="{ text: 'Next', type: 'primary' }"
              >
              </wm-common-button>
            </div>
          </div>

          <!-- ── Renew: Roles ── -->
          <div *ngSwitchCase="'renew-roles'">
            <div
              *ngFor="
                let mapping of renewWorkflowConfig?.roleMappings?.mappings || []
              "
              class="card-box mb-2"
            >
              <div class="row align-items-center">
                <div class="col-5">
                  <small class="text-muted">Source role</small>
                  <div class="font-weight-medium">
                    {{ mapping.sourceRoleName }}
                  </div>
                </div>
                <div class="col-1 text-center text-muted">&rarr;</div>
                <div class="col-6">
                  <small class="text-muted"
                    >Maps to target role
                    <span class="text-danger">*</span></small
                  >
                  <select
                    class="form-control form-control-sm"
                    [(ngModel)]="mapping.targetRoleId"
                  >
                    <option [value]="null">+ Add Role to Destination</option>
                    <option
                      *ngFor="
                        let role of renewWorkflowOptions
                          ?.targetJurisdictionResources?.responsibleRoles
                      "
                      [value]="role.id"
                      >{{ role.name }}</option
                    >
                  </select>
                </div>
              </div>
            </div>
            <div class="import-modal-actions">
              <wm-common-button
                (click)="
                  section.completed = true;
                  renewWorkflowConfig.roleMappings.completed = true;
                  nextSection()
                "
                [data]="{ text: 'Next', type: 'primary' }"
              >
              </wm-common-button>
            </div>
          </div>

          <!-- ── Register: Custom Lists ── -->
          <div *ngSwitchCase="'register-custom-lists'">
            <div
              *ngFor="
                let cl of registerWorkflowConfig?.customListMappings
                  ?.mappings || []
              "
              class="card-box mb-2"
            >
              <div class="row align-items-start">
                <div class="col-5">
                  <small class="text-muted">Source list</small>
                  <div class="font-weight-medium">{{ cl.sourceListName }}</div>
                </div>
                <div class="col-1 text-center text-muted mt-3">&rarr;</div>
                <div class="col-6">
                  <small class="text-muted"
                    >Target list <span class="text-danger">*</span></small
                  >
                  <select
                    class="form-control form-control-sm"
                    [(ngModel)]="cl.targetListId"
                  >
                    <option [value]="null">+ Create New List</option>
                    <option
                      *ngFor="
                        let list of registerWorkflowOptions
                          ?.targetJurisdictionResources?.customLists
                      "
                      [value]="list.id"
                      >{{ list.name }}</option
                    >
                  </select>
                  <!-- Item-level mappings when target list is selected -->
                  <div
                    *ngIf="cl.targetListId && (cl.itemMappings?.length ?? 0) > 0"
                    class="mt-2"
                  >
                    <small class="text-muted d-block mb-1">Item Mappings</small>
                    <div
                      *ngFor="let item of cl.itemMappings"
                      class="d-flex align-items-center gap-2 mb-1"
                    >
                      <span class="flex-grow-1 small">{{
                        item.sourceItem?.value
                      }}</span>
                      <span class="text-muted mx-1">&rarr;</span>
                      <select
                        class="form-control form-control-sm"
                        style="max-width: 160px"
                        [(ngModel)]="item.targetItemId"
                      >
                        <option [value]="null">+ Add as new item</option>
                        <option
                          *ngFor="
                            let targetItem of (
                              registerWorkflowOptions
                                ?.targetJurisdictionResources?.customLists
                              | filterById: cl.targetListId
                            )?.items
                          "
                          [value]="targetItem.id"
                          >{{ targetItem.value }}</option
                        >
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="import-modal-actions">
              <wm-common-button
                (click)="
                  section.completed = true;
                  registerWorkflowConfig.customListMappings.completed = true;
                  nextSection()
                "
                [data]="{ text: 'Next', type: 'primary' }"
              >
              </wm-common-button>
            </div>
          </div>

          <!-- ── Renew: Custom Lists ── -->
          <div *ngSwitchCase="'renew-custom-lists'">
            <div
              *ngFor="
                let cl of renewWorkflowConfig?.customListMappings?.mappings ||
                  []
              "
              class="card-box mb-2"
            >
              <div class="row align-items-start">
                <div class="col-5">
                  <small class="text-muted">Source list</small>
                  <div class="font-weight-medium">{{ cl.sourceListName }}</div>
                </div>
                <div class="col-1 text-center text-muted mt-3">&rarr;</div>
                <div class="col-6">
                  <small class="text-muted"
                    >Target list <span class="text-danger">*</span></small
                  >
                  <select
                    class="form-control form-control-sm"
                    [(ngModel)]="cl.targetListId"
                  >
                    <option [value]="null">+ Create New List</option>
                    <option
                      *ngFor="
                        let list of renewWorkflowOptions
                          ?.targetJurisdictionResources?.customLists
                      "
                      [value]="list.id"
                      >{{ list.name }}</option
                    >
                  </select>
                </div>
              </div>
            </div>
            <div class="import-modal-actions">
              <wm-common-button
                (click)="
                  section.completed = true;
                  renewWorkflowConfig.customListMappings.completed = true;
                  nextSection()
                "
                [data]="{ text: 'Next', type: 'primary' }"
              >
              </wm-common-button>
            </div>
          </div>

          <!-- ── Register / Renew: Fee Recipients ── -->
          <div *ngSwitchCase="'register-fee-recipients'">
            <div
              *ngFor="
                let mapping of registerWorkflowConfig?.feeRecipientMappings
                  ?.mappings || []
              "
              class="card-box mb-2"
            >
              <div class="toggle-row mb-2">
                <input type="checkbox" [(ngModel)]="mapping.isIgnored" /> &nbsp;
                <small>Don't use this Fee Recipient</small>
              </div>
              <div class="row align-items-center" *ngIf="!mapping.isIgnored">
                <div class="col-5">
                  <small class="text-muted">{{ mapping.sourceValue }}</small>
                </div>
                <div class="col-1 text-center text-muted">&rarr;</div>
                <div class="col-6">
                  <select
                    class="form-control form-control-sm"
                    [(ngModel)]="mapping.targetId"
                  >
                    <option [value]="null"
                      >+ Add Fee Recipient to Destination</option
                    >
                    <option
                      *ngFor="
                        let fr of registerWorkflowOptions
                          ?.targetJurisdictionResources?.feeRecipients
                      "
                      [value]="fr.id"
                      >{{ fr.value }}</option
                    >
                  </select>
                </div>
              </div>
            </div>
            <div class="import-modal-actions">
              <wm-common-button
                (click)="
                  section.completed = true;
                  registerWorkflowConfig.feeRecipientMappings.completed = true;
                  nextSection()
                "
                [data]="{ text: 'Next', type: 'primary' }"
              >
              </wm-common-button>
            </div>
          </div>

          <div *ngSwitchCase="'renew-fee-recipients'">
            <div
              *ngFor="
                let mapping of renewWorkflowConfig?.feeRecipientMappings
                  ?.mappings || []
              "
              class="card-box mb-2"
            >
              <div class="toggle-row mb-2">
                <input type="checkbox" [(ngModel)]="mapping.isIgnored" /> &nbsp;
                <small>Don't use this Fee Recipient</small>
              </div>
              <div class="row align-items-center" *ngIf="!mapping.isIgnored">
                <div class="col-5">
                  <small class="text-muted">{{ mapping.sourceValue }}</small>
                </div>
                <div class="col-1 text-center text-muted">&rarr;</div>
                <div class="col-6">
                  <select
                    class="form-control form-control-sm"
                    [(ngModel)]="mapping.targetId"
                  >
                    <option [value]="null"
                      >+ Add Fee Recipient to Destination</option
                    >
                    <option
                      *ngFor="
                        let fr of renewWorkflowOptions
                          ?.targetJurisdictionResources?.feeRecipients
                      "
                      [value]="fr.id"
                      >{{ fr.value }}</option
                    >
                  </select>
                </div>
              </div>
            </div>
            <div class="import-modal-actions">
              <wm-common-button
                (click)="
                  section.completed = true;
                  renewWorkflowConfig.feeRecipientMappings.completed = true;
                  nextSection()
                "
                [data]="{ text: 'Next', type: 'primary' }"
              >
              </wm-common-button>
            </div>
          </div>

          <!-- ── Email Footers ── -->
          <div *ngSwitchCase="'register-email-footers'">
            <div
              *ngFor="
                let mapping of registerWorkflowConfig?.emailFooterMappings
                  ?.mappings || []
              "
              class="card-box mb-2"
            >
              <div class="row align-items-center">
                <div class="col-5">
                  <div class="font-weight-medium">
                    {{ mapping.sourceEmailFooter?.label }}
                  </div>
                </div>
                <div class="col-1 text-center text-muted">&rarr;</div>
                <div class="col-6">
                  <select
                    class="form-control form-control-sm"
                    [(ngModel)]="mapping.targetId"
                  >
                    <option [value]="null">+ Create New Footer</option>
                    <option
                      *ngFor="
                        let ef of registerWorkflowOptions
                          ?.targetJurisdictionResources?.emailFooters
                      "
                      [value]="ef.id"
                      >{{ ef.label }}</option
                    >
                  </select>
                </div>
              </div>
            </div>
            <div class="import-modal-actions">
              <wm-common-button
                (click)="
                  section.completed = true;
                  registerWorkflowConfig.emailFooterMappings.completed = true;
                  nextSection()
                "
                [data]="{ text: 'Next', type: 'primary' }"
              >
              </wm-common-button>
            </div>
          </div>

          <div *ngSwitchCase="'renew-email-footers'">
            <div
              *ngFor="
                let mapping of renewWorkflowConfig?.emailFooterMappings
                  ?.mappings || []
              "
              class="card-box mb-2"
            >
              <div class="row align-items-center">
                <div class="col-5">
                  <div class="font-weight-medium">
                    {{ mapping.sourceEmailFooter?.label }}
                  </div>
                </div>
                <div class="col-1 text-center text-muted">&rarr;</div>
                <div class="col-6">
                  <select
                    class="form-control form-control-sm"
                    [(ngModel)]="mapping.targetId"
                  >
                    <option [value]="null">+ Create New Footer</option>
                    <option
                      *ngFor="
                        let ef of renewWorkflowOptions
                          ?.targetJurisdictionResources?.emailFooters
                      "
                      [value]="ef.id"
                      >{{ ef.label }}</option
                    >
                  </select>
                </div>
              </div>
            </div>
            <div class="import-modal-actions">
              <wm-common-button
                (click)="
                  section.completed = true;
                  renewWorkflowConfig.emailFooterMappings.completed = true;
                  nextSection()
                "
                [data]="{ text: 'Next', type: 'primary' }"
              >
              </wm-common-button>
            </div>
          </div>

          <!-- ── Fees (Register / Renew) ── -->
          <div *ngSwitchCase="'register-fees'">
            <form [formGroup]="registerFeeUpdatesForm">
              <div
                *ngFor="
                  let feeDE of registerWorkflowConfig?.feeUpdates
                    ?.feeDataEntities
                "
                class="card-box mb-3"
              >
                <div class="fee-title mb-2">
                  <strong>{{ feeDE?.label }}</strong>
                </div>
                <div class="fee-editor">
                  <wm-fee-data-entity-editor
                    [form]="registerFeeUpdatesForm?.controls?.[feeDE.templateCode]"
                    [dataEntity]="feeDE"
                    [activity]="feeDE.parentActivitySurrogate"
                    [workflowVersionId]="
                      registerWorkflowConfig.sourceWorkflowVersionId
                    "
                    [targetClientId]="data.targetClientId"
                    [showManageFeeRecipientsLink]="false"
                  >
                  </wm-fee-data-entity-editor>
                </div>
              </div>
            </form>
            <div class="import-modal-actions">
              <wm-common-button
                (click)="
                  section.completed = true;
                  registerWorkflowConfig.feeUpdates.completed = true;
                  nextSection()
                "
                [disabled]="registerFeeUpdatesForm?.invalid"
                [data]="{ text: 'Next', type: 'primary' }"
              >
              </wm-common-button>
            </div>
          </div>

          <div *ngSwitchCase="'renew-fees'">
            <form [formGroup]="renewFeeUpdatesForm">
              <div
                *ngFor="
                  let feeDE of renewWorkflowConfig?.feeUpdates?.feeDataEntities
                "
                class="card-box mb-3"
              >
                <div class="fee-title mb-2">
                  <strong>{{ feeDE?.label }}</strong>
                </div>
                <div class="fee-editor">
                  <wm-fee-data-entity-editor
                    [form]="renewFeeUpdatesForm?.controls?.[feeDE.templateCode]"
                    [dataEntity]="feeDE"
                    [activity]="feeDE.parentActivitySurrogate"
                    [workflowVersionId]="
                      renewWorkflowConfig.sourceWorkflowVersionId
                    "
                    [targetClientId]="data.targetClientId"
                    [showManageFeeRecipientsLink]="false"
                  >
                  </wm-fee-data-entity-editor>
                </div>
              </div>
            </form>
            <div class="import-modal-actions">
              <wm-common-button
                (click)="
                  section.completed = true;
                  renewWorkflowConfig.feeUpdates.completed = true;
                  nextSection()
                "
                [disabled]="renewFeeUpdatesForm?.invalid"
                [data]="{ text: 'Next', type: 'primary' }"
              >
              </wm-common-button>
            </div>
          </div>

          <!-- ── Emails (Register / Renew) ── -->
          <div *ngSwitchCase="'register-emails'">
            <form [formGroup]="registerEmailUpdatesForm">
              <mat-accordion multi="false">
                <mat-expansion-panel
                  *ngFor="
                    let emailActivity of registerWorkflowConfig?.emailUpdates
                      ?.emailActivities;
                    let i = index
                  "
                  [expanded]="expandedRegisterEmailIndex === i"
                  (opened)="expandedRegisterEmailIndex = i"
                  class="custom-panel"
                  [hideToggle]="true"
                >
                  <mat-expansion-panel-header>
                    <mat-panel-title class="panel-title">{{
                      emailActivity.model?.screenName
                    }}</mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="section-body">
                    <wm-email-activity-editor
                      *ngIf="expandedRegisterEmailIndex === i"
                      [workflowVersionId]="
                        registerWorkflowConfig.sourceWorkflowVersionId
                      "
                      [form]="registerEmailUpdatesForm?.controls?.[emailActivity.id]"
                      [activity]="emailActivity"
                      [viewInModal]="false"
                      [loadFull]="true"
                      [showEmailFooterManagementLink]="false"
                      [hideHeader]="true"
                      [targetClientId]="data.targetClientId"
                    >
                    </wm-email-activity-editor>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </form>
            <div class="import-modal-actions">
              <wm-common-button
                (click)="
                  section.completed = true;
                  registerWorkflowConfig.emailUpdates.completed = true;
                  nextSection()
                "
                [data]="{ text: 'Next', type: 'primary' }"
              >
              </wm-common-button>
            </div>
          </div>

          <div *ngSwitchCase="'renew-emails'">
            <form [formGroup]="renewEmailUpdatesForm">
              <mat-accordion multi="false">
                <mat-expansion-panel
                  *ngFor="
                    let emailActivity of renewWorkflowConfig?.emailUpdates
                      ?.emailActivities;
                    let i = index
                  "
                  [expanded]="expandedRenewEmailIndex === i"
                  (opened)="expandedRenewEmailIndex = i"
                  class="custom-panel"
                  [hideToggle]="true"
                >
                  <mat-expansion-panel-header>
                    <mat-panel-title class="panel-title">{{
                      emailActivity.model?.screenName
                    }}</mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="section-body">
                    <wm-email-activity-editor
                      *ngIf="expandedRenewEmailIndex === i"
                      [workflowVersionId]="
                        renewWorkflowConfig.sourceWorkflowVersionId
                      "
                      [form]="renewEmailUpdatesForm?.controls?.[emailActivity.id]"
                      [activity]="emailActivity"
                      [viewInModal]="false"
                      [loadFull]="true"
                      [showEmailFooterManagementLink]="false"
                      [hideHeader]="true"
                      [targetClientId]="data.targetClientId"
                    >
                    </wm-email-activity-editor>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </form>
            <div class="import-modal-actions">
              <wm-common-button
                (click)="
                  section.completed = true;
                  renewWorkflowConfig.emailUpdates.completed = true;
                  nextSection()
                "
                [data]="{ text: 'Next', type: 'primary' }"
              >
              </wm-common-button>
            </div>
          </div>

          <!-- ── Print Templates ── -->
          <div *ngSwitchCase="'register-print-templates'">
            <form
              *ngIf="
                registerPrintTemplateFormReady &&
                registerPrintTemplateUpdatesForm
              "
              [formGroup]="registerPrintTemplateUpdatesForm"
            >
              <div
                *ngFor="
                  let activity of registerWorkflowConfig?.printTemplateUpdates
                    ?.printTemplateActivities
                "
                class="card-box mb-3"
              >
                <wm-common-text
                  [data]="{ text: activity?.model?.screenName }"
                ></wm-common-text>
                <wm-print-template-activity-editor
                  *ngIf="
                    expandedIndex === i &&
                    registerPrintTemplateFormReady &&
                    registerPrintTemplateUpdatesForm?.get(activity.id)
                  "
                  [workflowVersionId]="
                    registerWorkflowConfig.sourceWorkflowVersionId
                  "
                  [workflow]="registerWorkflowObj"
                  [activity]="activity"
                  [form]="registerPrintTemplateUpdatesForm.get(activity.id)"
                >
                </wm-print-template-activity-editor>
              </div>
            </form>
            <div
              class="import-modal-actions"
              *ngIf="registerPrintTemplateFormReady"
            >
              <wm-common-button
                (click)="
                  section.completed = true;
                  registerWorkflowConfig.printTemplateUpdates.completed = true;
                  nextSection()
                "
                [data]="{ text: 'Next', type: 'primary' }"
              >
              </wm-common-button>
            </div>
          </div>

          <div *ngSwitchCase="'renew-print-templates'">
            <form
              *ngIf="
                renewPrintTemplateFormReady && renewPrintTemplateUpdatesForm
              "
              [formGroup]="renewPrintTemplateUpdatesForm"
            >
              <div
                *ngFor="
                  let activity of renewWorkflowConfig?.printTemplateUpdates
                    ?.printTemplateActivities
                "
                class="card-box mb-3"
              >
                <wm-common-text
                  [data]="{ text: activity?.model?.screenName }"
                ></wm-common-text>
                <wm-print-template-activity-editor
                  *ngIf="
                    expandedIndex === i &&
                    renewPrintTemplateFormReady &&
                    renewPrintTemplateUpdatesForm?.get(activity.id)
                  "
                  [workflowVersionId]="
                    renewWorkflowConfig.sourceWorkflowVersionId
                  "
                  [workflow]="renewWorkflowObj"
                  [activity]="activity"
                  [form]="renewPrintTemplateUpdatesForm.get(activity.id)"
                >
                </wm-print-template-activity-editor>
              </div>
            </form>
            <div
              class="import-modal-actions"
              *ngIf="renewPrintTemplateFormReady"
            >
              <wm-common-button
                (click)="
                  section.completed = true;
                  renewWorkflowConfig.printTemplateUpdates.completed = true;
                  nextSection()
                "
                [data]="{ text: 'Next', type: 'primary' }"
              >
              </wm-common-button>
            </div>
          </div>

          <!-- ── Tags ── -->
          <div *ngSwitchCase="'tags'">
            <div *ngFor="let mapping of tagMappings" class="card-box mb-2">
              <div class="row align-items-center">
                <div class="col-5">
                  <span class="badge badge-info">{{ mapping.sourceName }}</span>
                </div>
                <div class="col-1 text-center text-muted">&rarr;</div>
                <div class="col-6">
                  <select
                    class="form-control form-control-sm"
                    [(ngModel)]="mapping.targetTagId"
                  >
                    <option [value]="null">+ Create New Tag</option>
                    <option
                      *ngFor="let tag of availableTags"
                      [value]="tag.id"
                      >{{ tag.name }}</option
                    >
                  </select>
                </div>
              </div>
            </div>
            <div class="import-modal-actions">
              <wm-common-button
                (click)="section.completed = true; nextSection()"
                [data]="{ text: 'Next', type: 'primary' }"
              >
              </wm-common-button>
            </div>
          </div>

          <!-- ── Review & Import ── -->
          <div *ngSwitchCase="'review'">
            <div class="review-summary mb-3">
              <div class="review-row">
                <span class="text-muted">Contractor Type Name</span
                ><strong>{{ ctSettingsForm?.value?.name }}</strong>
              </div>
              <div class="review-row">
                <span class="text-muted">Register Workflow</span
                ><strong>{{
                  registerWorkflowConfig?.workflowUpdates?.name
                }}</strong>
              </div>
              <div class="review-row">
                <span class="text-muted">Renew Workflow</span
                ><strong>{{
                  renewWorkflowConfig?.workflowUpdates?.name
                }}</strong>
              </div>
              <div class="review-row">
                <span class="text-muted">Tags</span
                ><strong>{{ tagMappings?.length || 0 }} mapped</strong>
              </div>
            </div>
            <div class="import-modal-actions">
              <wm-common-button
                (click)="close()"
                [data]="{ text: 'Cancel', type: 'secondary' }"
              >
              </wm-common-button>
              <wm-common-button
                (click)="finishImport()"
                [disabled]="isSaving || !allSectionsCompleted"
                [data]="{
                  text: isSaving ? 'Importing...' : 'Import',
                  type: 'success'
                }"
              >
              </wm-common-button>
            </div>
          </div>
        </ng-container>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</mat-dialog-content>
